// Texte d'aide des horaires de disponibilité, identique sur PackForm et ProductForm (spec §5.7).
export const TEXTE_AIDE_HORAIRES =
  'Ces horaires s\'appliquent à la caisse, à la commande en ligne et à la borne. Pour Uber Eats, Deliveroo et Just Eat, demandez l\'activation à support@tickeat.io.';
